<template>
<header class="bg-gradient-dark">
    <div class="page-header min-vh-75 relative" v-bind:style="{ 'background-image': 'url(' + require('@/assets/img/curved-images/curved5-small.jpg') + ')' }">
        <span class="mask bg-gradient-dark opacity-8"></span>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 text-center mx-auto my-auto">
                    <h1 class="text-white">Contact</h1>
                </div>
            </div>
        </div>
        <div class="position-absolute w-100 z-index-1 bottom-0">
            <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 40" preserveAspectRatio="none" shape-rendering="auto">
                <defs>
                    <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                </defs>
                <g class="moving-waves">
                    <use xlink:href="#gentle-wave" x="48" y="-1" fill="rgba(255,255,255,0.40" />
                    <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.35)" />
                    <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.25)" />
                    <use xlink:href="#gentle-wave" x="48" y="8" fill="rgba(255,255,255,0.20)" />
                    <use xlink:href="#gentle-wave" x="48" y="13" fill="rgba(255,255,255,0.15)" />
                    <use xlink:href="#gentle-wave" x="48" y="16" fill="rgba(255,255,255,1" />
                </g>
            </svg>
        </div>
    </div>
</header>
<section class="py-7 contact-us">
    <div class="container">
        <div class="row">
            <div class="col-md-7">
                <div class="section-title">
                    <h2 class="mb-6 mr-3">Contact Us
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" /> </svg>
                    </h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7">
                <div class="mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="60" zoomAndPan="magnify" viewBox="0 0 30 30.000001" preserveAspectRatio="xMidYMid meet" version="1.0">
                        <defs>
                            <clipPath id="id1">
                                <path d="M 10 7 L 21.046875 7 L 21.046875 25.875 L 10 25.875 Z M 10 7 " clip-rule="nonzero" />
                            </clipPath>
                            <clipPath id="id2">
                                <path d="M 7 3.375 L 16 3.375 L 16 10 L 7 10 Z M 7 3.375 " clip-rule="nonzero" />
                            </clipPath>
                            <clipPath id="id3">
                                <path d="M 5.804688 6 L 12 6 L 12 15 L 5.804688 15 Z M 5.804688 6 " clip-rule="nonzero" />
                            </clipPath>
                            <clipPath id="id4">
                                <path d="M 11 3.375 L 21 3.375 L 21 14 L 11 14 Z M 11 3.375 " clip-rule="nonzero" />
                            </clipPath>
                        </defs>
                        <g clip-path="url(#id1)">
                            <path fill="rgb(28.239441%, 70.979309%, 39.219666%)" d="M 19.820312 15.644531 L 19.828125 15.644531 C 19.828125 15.644531 17.777344 18.679688 16.050781 20.933594 C 14.5625 22.882812 14.125 24.550781 14 25.359375 C 13.953125 25.652344 13.714844 25.875 13.425781 25.875 C 13.136719 25.875 12.898438 25.652344 12.847656 25.359375 C 12.722656 24.550781 12.289062 22.882812 10.796875 20.933594 C 10.570312 20.632812 10.335938 20.320312 10.101562 20 L 15.730469 13.25 L 20.261719 7.828125 C 20.761719 8.886719 21.039062 10.074219 21.039062 11.332031 C 21.039062 12.921875 20.589844 14.398438 19.820312 15.644531 Z M 19.820312 15.644531 " fill-opacity="1" fill-rule="nonzero" />
                        </g>
                        <path fill="rgb(98.81897%, 77.648926%, 5.488586%)" d="M 15.730469 13.25 L 10.101562 20 C 8.566406 17.925781 7.023438 15.644531 7.023438 15.644531 L 7.027344 15.644531 C 6.863281 15.378906 6.71875 15.113281 6.59375 14.832031 L 11.117188 9.410156 C 10.6875 9.929688 10.433594 10.601562 10.433594 11.332031 C 10.433594 13 11.769531 14.347656 13.425781 14.347656 C 14.355469 14.347656 15.1875 13.921875 15.730469 13.25 Z M 15.730469 13.25 " fill-opacity="1" fill-rule="nonzero" />
                        <g clip-path="url(#id2)">
                            <path fill="rgb(17.248535%, 52.159119%, 92.158508%)" d="M 15.816406 3.78125 L 11.15625 9.367188 L 7.589844 6.226562 C 8.980469 4.480469 11.082031 3.375 13.425781 3.375 C 14.261719 3.375 15.066406 3.515625 15.816406 3.78125 Z M 15.816406 3.78125 " fill-opacity="1" fill-rule="nonzero" />
                        </g>
                        <g clip-path="url(#id3)">
                            <path fill="rgb(92.939758%, 34.118652%, 28.239441%)" d="M 11.15625 9.367188 L 11.117188 9.410156 L 6.59375 14.832031 C 6.09375 13.773438 5.808594 12.585938 5.808594 11.332031 C 5.808594 9.386719 6.480469 7.605469 7.589844 6.226562 Z M 11.15625 9.367188 " fill-opacity="1" fill-rule="nonzero" />
                        </g>
                        <g clip-path="url(#id4)">
                            <path fill="rgb(33.729553%, 58.428955%, 96.469116%)" d="M 15.730469 13.25 C 16.160156 12.730469 16.417969 12.058594 16.417969 11.332031 C 16.417969 9.664062 15.078125 8.3125 13.425781 8.3125 C 12.496094 8.3125 11.664062 8.742188 11.117188 9.410156 L 15.816406 3.78125 C 17.769531 4.449219 19.371094 5.925781 20.261719 7.828125 Z M 15.730469 13.25 " fill-opacity="1" fill-rule="nonzero" />
                        </g>
                    </svg>
                </div>
                <h5 class="mb-4">PRECIS Research Center</h5>
                <h5 class="mb-4">Faculty of Automatic Control and Computers</h5>
                <h5 class="mb-4">University Politehnica of Bucharest</h5>
                <h5 class="mb-4">Address: Splaiul Independentei, no. 313, district 6, Bucharest, RO-060042, Romania</h5>
                <div class="mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" /> </svg>
                </div>
                <h5 class="mb-4">E-mail: mihai.dascalu@upb.ro</h5>
            </div>

            <div class="col-lg-5">
                <div class="map">
                    <iframe width="100%" height="400" id="gmap_canvas" src="https://maps.google.com/maps?q=PRECIS%20Center,%20Bucharest,%20Romania&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

  
<style lang="scss" scoped>
.contact-us textarea {
    min-height: 188px;
    max-width: 100%;
}

.contact-us .map {
    overflow: hidden;
    border-radius: 4px;
}
</style>
